export default __webpack_public_path__ + "static/media/download-icon.b8aa2257.svg";